import React from 'react';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import Avatar from '../../../avatar/index';
import {API_ROOT, APP_ID} from '../../../../utils';
import {getProfile} from '../../../../../actions/profileActions';
import Icon from '../../../icon';
import "./index.css";
import Button from '../../../button';
import {NavLink} from 'react-router-dom';

class ProfileInfo extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            toggleDropdown: false,
            isInstallingAdmin: false
        };

        this.popupTimer = null;
        this.profileTimeout = null;

        this.handleClick = this.handleClick.bind(this);
        this.leaveHandler = this.leaveHandler.bind(this);
        this.handleAdminInstallClick = this.handleAdminInstallClick.bind(this);
    }

    componentWillUnmount() {
        if (this.popupTimer) {
            clearInterval(this.popupTimer);
        }
        if (this.profileTimeout) {
            clearTimeout(this.profileTimeout);
        }
    }

    handleClick () {
        this.setState((state) => ({
            toggleDropdown: !state.toggleDropdown
        }));
    }

    leaveHandler () {
        this.setState({
            toggleDropdown: false
        });
    }

    handleAdminInstallClick () {
        const { profile, dispatch } = this.props;
        if (!profile || this.state.isInstallingAdmin) {
            return;
        }

        const winRef = window.open(
            'https://workspace.google.com/marketplace/dwi/' + APP_ID + '?redirect_url=./marketplace/adminoauthpromptredirect&authuser=' + profile.email,
            'Popup',
            'popup=yes,width=800,height=600'
        );

        if (!winRef) {
            return;
        }

        this.setState({ isInstallingAdmin: true });

        if (this.popupTimer) {
            clearInterval(this.popupTimer);
        }

        this.popupTimer = setInterval(() => {
            if (winRef.closed) {
                clearInterval(this.popupTimer);
                this.popupTimer = null;

                this.profileTimeout = setTimeout(() => {
                    axios.get(`${API_ROOT}/api/util/domain/update_domain`, { withCredentials: true })
                        .catch(() => {})
                        .finally(() => {
                            dispatch(getProfile(true));
                            this.setState({ isInstallingAdmin: false });
                        });
                }, 5000);
            }
        }, 1000);
    }

    render(){
        if(this.props.profile !== null){
            const isWorkspaceIndividualInstall = Boolean(
                this.props.profile.domain
                && this.props.profile.domain.gsuiteDomain
                && (
                    this.props.profile.domain.installType === 'INDIVIDUAL'
                    || (
                        !this.props.profile.domain.installType
                        && this.props.profile.accessStatus
                        && this.props.profile.accessStatus.isDomainApisGranted === false
                    )
                )
            );

	        return (
		        <div className="profile-info">
                    <div className="profile-info__user">
                        <div className="profile-info__welcome">
                            <p onClick={this.handleClick}>{this.props.t("textHi")} <strong>{this.props.profile.name}</strong></p>
	                        <p>{this.props.profile.email}</p>
                        </div>
                        <Avatar onClick={this.handleClick} size={36} src={`${API_ROOT}/account/avatar/${this.props.profile.id}`} alt={this.props.profile.name}/>
                        {
                            this.state.toggleDropdown &&
                            <div className="profile-info__details" onMouseLeave={this.leaveHandler}>
	                            <ul>
		                            <li>
			                            <NavLink className="text-nowrap" to={'/my-profile'}>
				                            <Icon name="user" className="mr-2"/>
				                            {this.props.t("myProfile")}
			                            </NavLink>
		                            </li>
		                            <li>
			                            <a className="text-nowrap" href={`${API_ROOT}/account/logout/`} onClick={() => window.webful?.reset()}>
				                            <Icon name="sign-out" className="mr-2"/>
				                            {this.props.t("textLogOut")}
			                            </a>
		                            </li>
	                            </ul>
                            </div>
                        }
                        <div>
	                        <Button className="expend" onClick={this.handleClick}><Icon name="ellipsis-v"/></Button>
                        </div>
                    </div>
                    {
                        isWorkspaceIndividualInstall && (
                            <div className="profile-info__admin-install">
                                <Button
                                    className="btn-outline-default profile-info__admin-install-btn"
                                    disabled={this.state.isInstallingAdmin}
                                    onClick={this.handleAdminInstallClick}
                                >
                                    {
                                        this.state.isInstallingAdmin
                                            ? <Icon animated="pulse" name="spinner"/>
                                            : this.props.t("adminInstallBtn", "Admin Install")
                                    }
                                </Button>
                            </div>
                        )
                    }
		        </div>
	        )
        } else {
            return null
        }
    }
}

const mapStateToProps = (state) => {
	return {
		profile : state.profileReducer.getProfile
	};
};

export default connect(mapStateToProps)(withTranslation()(ProfileInfo));
